
import {throwError as observableThrowError, Observable} from 'rxjs';

import {tap, catchError, map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {LoaderService} from './loader/loader.service';


import {Router} from '@angular/router';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService, private router: Router) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('userLogged');

    this.loaderService.show();

    if (token) {
      const authReq = req.clone(
        {
          headers: req.headers.set('token', token)
        });

      // next.handle(authReq).do((event: HttpEvent<any>) => {
      //   console.log(event);
      //
      //   this.loaderService.hide();
      // }, err => {
      //   this.loaderService.hide();
      //
      //   if (err instanceof HttpErrorResponse && err.status === 412) {
      //     this.router.navigate(['/login']);
      //   }
      // });

      return next.handle(authReq).pipe(
        map((res: any) => {
          // console.log('headers:');
          // console.log(res.headers);

          const body = res.body;

          if (body) {
            // console.log('res ', res);
            // console.log('data ', body);
          }

          this.loaderService.hide();

          return res;
        }),
        catchError((err: any) => {
          console.log('error ', err);

          this.loaderService.hide();

          if (err instanceof HttpErrorResponse && err.status === 412) {
            this.router.navigate(['../login']);
          }

          if (err) {
            console.log(err);
          }
          return observableThrowError(err);
        }));
    } else {
      return next.handle(req).pipe(tap((event: HttpEvent<any>) => {
        this.loaderService.hide();
      }, err => {
        this.loaderService.hide();

        if (err instanceof HttpErrorResponse && err.status === 412) {
          this.router.navigate(['/login']);
        }
      }));
    }
  }
}
